import React from 'react'
import { useNavigate } from 'react-router-dom'
// Components
import PageTransition from '../components/PageTransition'

export default function OrderTracking() {
  const navigate = useNavigate();

  const submitForm = event => {
    event.preventDefault();
    navigate('/order-tracking/'+event.target.order_id.value);
  }

  return (
    <div className='order_tracking_page'>
      <PageTransition />
      <div className='container' style={{maxWidth: '500px'}}>
        <form className='order_tracking_form default' onSubmit={submitForm}>
          <div className='form_header'>
            <div className='title'>Track Your Order</div>
          </div>
          <div className='inputs'>
            <div className='input_container'>
              <label className='label'>Order Id</label>
              <input className='input' type='text' name='order_id' placeholder='Enter your order ID' required />
            </div>
          </div>
          <div className='actions'>
            <button className='submit_btn'>Track Order</button>
          </div>
        </form>
      </div>
    </div>
  )
}
